import api from './api';

export interface TipoModulo {
  id: string;
  codigo: string;
  nome: string;
}

export interface CreatTipoModulo {
  id: string
  codigo: string;
  nome: string;
}

export const getAllTipoModulo = () => api.get<TipoModulo[]>('tipoModulo');
export const creatTipoModulo = (values: CreatTipoModulo) => api.post<CreatTipoModulo>('tipoModulo', values);
export const updateTipoModulo = (id: string, values: CreatTipoModulo) => api.put<CreatTipoModulo>(`tipoModulo/${id}`, values);